// const HOST = "http://192.168.10.120:3031/";
const HOST = "https://denisapi.appdeft.in/";
// const HOST = "https://apiv2.denis-kebap.at/";
// const HOST = "https://deceitful-unenameled-angelia.ngrok-free.dev/";
const BASE_URL = HOST + "api/admin";

export { BASE_URL, HOST };
